import Service from "../../Services";

const FreePage = {
  namespaced : true,
  state : {
    form : {
      is_publish : true,
      title_th : '',
      title_en : '',
      detail_en : '',
      detail_th : '',
      slug_url : '',
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        is_publish : true,
        title_th : '',
        title_en : '',
        detail_en : '',
        detail_th : '',
        slug_url : '',
      }
    }
  },
  actions : {
    getFreePage({commit}, {page,search,sort}){
      return Service.FreePageAPI.getFreePage(page,search,sort);
    },
    showFreePage({commit},id){
      return Service.FreePageAPI.showFreePage(id);
    },
    saveFreePage({commit},{id,data}){
      if(id){
        return Service.FreePageAPI.updateFreePage(id,data);
      }else{
        return Service.FreePageAPI.createFreePage(data);
      }
    },
    deleteFreePage({commit},id){
      return Service.FreePageAPI.deleteFreePage(id);
    },
    setFormFreePage({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    },
    checkingSlug({commit}, slug){
      return Service.FreePageAPI.checkSlugFreePage(slug);
    }
  },
}
export default FreePage
